import { useRecoilValue } from 'recoil';

import { usersState } from '../../../entities/users';
import { userFunctionsState } from '../../../state/userFunctions';
import type { ProjectTaskDefaultFilters } from '../../../types';
import type { ProjectTasksFormFilerValue } from './types';

export function useDefaultFilters(filtersState: ProjectTaskDefaultFilters): ProjectTasksFormFilerValue {
  const allUsers = useRecoilValue(usersState);
  const allUserFunctions = useRecoilValue(userFunctionsState);

  const {
    startDate,
    status,
    endDate,
    typeDate,
    responsible,
    userFunctions,
    participants,
    resolutionLevel,
    isAssignedToMe,
  } = filtersState;

  return {
    typeDate,
    endDate: endDate ?? null,
    startDate: startDate ?? null,
    status: status ?? undefined,
    userFunctions: allUserFunctions.filter((item) => userFunctions?.includes(item.id)),
    responsible: allUsers.filter((item) => responsible?.includes(item.id)),
    participants: allUsers.filter((item) => participants?.includes(item.id)),
    resolutionLevel: resolutionLevel ?? [],
    isAssignedToMe: isAssignedToMe ?? false,
  };
}
